<template>
  <div>
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
    <pt-detection-form ref="form" class="pt-detection-form__withData" v-model="formObj" :disabled="formObj.engineDefault"></pt-detection-form>
  </div>
</template>

<script>
import PtDetectionForm from './index'
export default {
  name: 'pt-detection-form__withData',
  components: {
    'pt-detection-form': PtDetectionForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formObj: {},
      loading: false,
      loadFailed: false
    }
  },
  methods: {
    // formValidate () {
    //   return this.form.validate()
    // }
    addDetectionFunc () {
      this.$emit('updateLoading', true)
      this.$store.dispatch('detectionAdd', this.formObj).then(data => {
        this.$emit('updateLoading', false)
        this.$message.success('新建成功!')
        this.$router.push({ name: 'detection-list' })
      }).catch(errorMessage => {
        this.$emit('updateLoading', false)
        console.error(errorMessage)
        this.$message.error(errorMessage)
      })
    },
    checkRepeat () {
      return this.$store.dispatch('getDetectionItemByName', this.formObj.chineseName).then(data => {
        return data
      }).catch(err => {
        return err
      })
    },
    submit () {
      this.form.validate().then(async formValue => {
        console.log(this.formObj)
        this.$emit('updateLoading', true)
        let checkRes = await this.checkRepeat()
        console.log('checkRes', checkRes)
        if (!checkRes.id) {
          this.addDetectionFunc()
        } else {
          this.$emit('updateLoading', false)
          this.$confirm(`已存在中文名称为“${checkRes.chineseName}”的检测项, 是否覆盖原内容?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.addDetectionFunc()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消覆盖'
            })
          })
        }
      })
    },
    edit () {
      this.form.validate().then(formValue => {
        this.$emit('updateLoading', true)
        this.$store.dispatch('updateDetection', this.formObj).then(data => {
          this.$emit('updateLoading', false)
          this.$message.success('编辑成功!')
          history.go(-1)
        }).catch(errorMessage => {
          this.$emit('updateLoading', false)
          console.error(errorMessage)
          this.$message.error(errorMessage)
        })
      })
    },
    load () {
      this.$emit('updateLoading', true)
      this.loadFailed = false
      this.$store.dispatch('getDetection', this.$route.params.id).then(res => {
        this.formObj = res.data
        this.$emit('upateCategory', this.formObj.category)
        this.$emit('upateEngineDefault', this.formObj.engineDefault)
        this.$emit('updateLoading', false)
        this.loadFailed = false
      }).catch(errorMessage => {
        this.$emit('updateLoading', false)
        console.error(errorMessage)
        this.$message.error(errorMessage)
        this.loadFailed = true
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
